<p-dialog
  [visible]="visible()"
  (visibleChange)="onHide()"
  [modal]="true"
  [draggable]="false"
  [resizable]="true"
  [maximizable]="true"
  [class]="'document-viewer-dialog'"
  [contentStyleClass]="'document-viewer-content'"
  appendTo="body"
>
  <!-- Header -->
  <ng-template pTemplate="header">
    @if (document(); as doc) {
      <div class="flex flex-col gap-1">
        <div class="flex items-center gap-3">
          <i [class]="'text-2xl'" [ngClass]="{
            'pi pi-file-pdf text-blue-500': doc.type === 'pdf',
            'pi pi-file-word text-blue-700': doc.type === 'word',
            'pi pi-file-excel text-green-600': doc.type === 'excel',
            'pi pi-file text-gray-500': doc.type === 'powerpoint'
          }"></i>
          <div class="flex-1">
            <h2 class="text-xl font-semibold m-0 text-(--text-color)">{{ doc.filename }}</h2>
            <div class="flex items-center gap-3 mt-1 text-sm text-(--text-color-secondary)">
              <span>{{ getDocumentTypeDisplay() }}</span>
              <span>•</span>
              <span>{{ formatFileSize(doc.size) }}</span>
              <span>•</span>
              <span>{{ getFormattedDate(doc.uploadedAt) }}</span>
            </div>
          </div>
        </div>
      </div>
    }
  </ng-template>

  <!-- Content -->
  @if (document(); as doc) {
    <div class="w-full">
      <!-- Document Info -->
      @if (doc.description || doc.tags.length > 0) {
        <div class="mb-4 p-4 bg-(--surface-50) rounded-lg border border-(--surface-border)">
          @if (doc.description) {
            <p class="text-sm text-(--text-color) mb-2">{{ doc.description }}</p>
          }
          @if (doc.tags.length > 0) {
            <div class="flex flex-wrap gap-2">
              @for (tag of doc.tags; track tag) {
                <span class="text-xs bg-(--primary-color) text-white px-2 py-1 rounded-full">
                  {{ tag }}
                </span>
              }
            </div>
          }
        </div>
      }

      <!-- PDF Viewer -->
      @if (isPdf()) {
        <div class="pdf-viewer-wrapper">
          <ngx-extended-pdf-viewer
            [src]="documentUrl()"
            [textLayer]="true"
            [showHandToolButton]="true"
            height="calc(70vh - 150px)"
            [filenameForDownload]="doc.filename"
          />
        </div>
      } @else {
        <!-- Non-PDF Document Message -->
        <div class="flex flex-col items-center justify-center py-12 text-center">
          <i class="pi pi-file text-6xl! text-(--text-color-secondary) mb-4"></i>
          <h3 class="text-lg font-semibold text-(--text-color) mb-2">
            Preview not available
          </h3>
          <p class="text-sm text-(--text-color-secondary) mb-6 max-w-md">
            This document type cannot be previewed in the browser. Please download it to view the contents.
          </p>
          <p-button
            label="Download Document"
            icon="pi pi-download"
            (onClick)="downloadDocument()"
            severity="primary"
          />
        </div>
      }
    </div>
  }

  <!-- Footer -->
  <ng-template pTemplate="footer">
    <div class="flex items-center justify-between w-full">
      <div class="flex gap-2">
        @if (document(); as doc) {
          <p-button
            label="Download"
            icon="pi pi-download"
            (onClick)="downloadDocument()"
            severity="secondary"
            [outlined]="true"
          />
        }
      </div>
      <p-button
        label="Close"
        icon="pi pi-times"
        (onClick)="onHide()"
        severity="secondary"
      />
    </div>
  </ng-template>
</p-dialog>
